import { Box, Card, Grid, Typography } from '@mui/material';
import * as React from 'react';

import WsAccountNotFoundIcon from '../../components/WsIcon/WsAccountNotFoundIcon';

interface IWsAccountNotFoundCard {
  account: string;
}

const WsAccountNotFoundCard = ({ account }: IWsAccountNotFoundCard) => (
  <Card
    elevation={3}
    sx={{
      p: 4,
      maxWidth: 500,
      mx: 'auto',
      my: 4,
      borderRadius: 2,
      backgroundColor: 'background.paper',
      border: 'none',
      boxShadow: 'none',
    }}
  >
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ textAlign: 'center' }}
    >
      <Grid item>
        <Box mb={2}>
          <WsAccountNotFoundIcon />
        </Box>
      </Grid>
      <Grid item>
        <Typography variant="h6" fontWeight={600} color="text.primary">
          No {account} Account
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body2" color="text.secondary" mt={1}>
          No account have been added. Please click ‘Add Account’.
        </Typography>
      </Grid>
    </Grid>
  </Card>
);

export default WsAccountNotFoundCard;
